import { RootState } from '@store/store.interface';
import { IDashboardOrgInfoData } from '@interfaces/dashboard';

const getState = (state: RootState) => state.dashboardOrgInfo;
export const dashboardOrgDataSelector = (state: RootState): IDashboardOrgInfoData | null =>
  getState(state).data;
export const dashboardOrgStatsSelector = (state: RootState) => getState(state).stats;
export const dashboardOrgDataIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const dashboardOrgDataIsReadySelector = (state: RootState) => getState(state).isReady;
export const dashboardOrgDataErrorSelector = (state: RootState) => getState(state).error;
export const canAccessSupplementInquirySelector = (state: RootState) =>
  dashboardOrgStatsSelector(state).supplementInquiry;
export const canAccessMedicationLookupSelector = (state: RootState) =>
  dashboardOrgStatsSelector(state).medicationLookup;
export const canAccessAdminSelector = (state: RootState) =>
  dashboardOrgStatsSelector(state).inquiryAdministration;
